// Shared Nationals "About Solo Awards Ceremony" card. Rendered in the homepage
// live banner and the Nationals stream Solo Awards tab so the copy stays in one
// place. Nationals-specific (NEW Solo Title Winners, Showroom 1 / Hall C, Sunday
// doors). Mirrors NationalsWrapItAbout's structure.

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/components/ui/accordion.tsx'

export function NationalsSoloAwardsAbout({
	className,
	collapsible = false,
	defaultOpen = true,
}: {
	className?: string
	/** Render as a collapsible accordion (stream tab) vs. a static card (homepage). */
	collapsible?: boolean
	/** Initial open state when collapsible. Expanded before the ceremony, collapsed on/after the day. */
	defaultOpen?: boolean
}) {
	const heading = (
		<h3
			className="font-bold uppercase tracking-wide"
			style={{ fontFamily: 'var(--font-display)' }}
		>
			About Solo Awards Ceremony
		</h3>
	)

	const body = (
		<p className="text-xs text-muted-foreground">
			Join us at our Solo Awards Ceremony for the announcement of our National
			Solo Winners for 2025-26 with over 20K in DanceMakers Scholarships! It
			will be hosted on Sunday, June 21st, in Showroom 1, with doors opening at
			8:20 pm and the show starting at 8:30 pm, and will stream live right here!
		</p>
	)

	if (collapsible) {
		return (
			<div
				className={`border border-muted-foreground/30 px-6${className ? ` ${className}` : ''}`}
			>
				<Accordion
					type="single"
					collapsible
					defaultValue={defaultOpen ? 'solo-about' : undefined}
				>
					<AccordionItem value="solo-about" className="border-b-0">
						<AccordionTrigger className="hover:no-underline">
							{heading}
						</AccordionTrigger>
						<AccordionContent className="pb-6">{body}</AccordionContent>
					</AccordionItem>
				</Accordion>
			</div>
		)
	}

	return (
		<div
			className={`border border-muted-foreground/30 p-6${className ? ` ${className}` : ''}`}
		>
			<div className="mb-3">{heading}</div>
			{body}
		</div>
	)
}
